import { IAdpCertificateFileShareSiteLinks } from "./adp-certificate-filesharesite-links";

export interface IAdpCertificatePrintResponse {
    data: {
        success: boolean;
        message: string;
        results: IAdpCertificateFileShareSiteLinks
    }
}